<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" isActive="information" />
    <div class="headerbg"><span>资讯中心</span><b> INFORMATION CENTER</b></div>
    <div class="mainbody">
      <div class="top-title">
        <div :class="{ active: isshow === 1 }" @click="toqysj">企业事纪</div>
        <div :class="{ active: isshow === 2 }" @click="tohyxw">行业资讯</div>
      </div>

      <el-carousel
        class="zixun"
        height="385px"
        indicator-position="none"
        arrow="never"
        trigger="click"
        ref="toploop"
        :interval=4000
      >
        <el-carousel-item v-for="item in topList" :key="item.id">
          <div class="loops">
            <img class="left" :src="item.coverImg" alt="" />
            <div class="right">
              <span @click="getMore(item)" class="title">
                {{ item.title }}
              </span>
              <span class="textbody">
                {{ item.baseDesc }}
              </span>
              <div class="time">{{ item.createDate }}</div>
              <div @click="getMore(item)" class="watchmore">查看更多></div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

      <div class="loop-line">
        <div @click="goleft" class="loopbox">
          <div class="leftline"></div>
        </div>
        <div @click="gocenter" class="loopbox">
          <div class="centerline"></div>
        </div>
        <div @click="goright" class="loopbox">
          <div class="rightline"></div>
        </div>
      </div>

      <div class="newsList">
        <div
          @click="toDetail(item)"
          v-for="item in pageList"
          :key="item.id"
          class="childnew"
        >
          <img :src="item.coverImg" alt="" />
          <div class="right-text">
            <div class="top">
              {{ item.title }}
            </div>
            <span class="center">
              {{ item.baseDesc }}
            </span>
            <div class="under-time">{{ item.createDate }}</div>
          </div>
        </div>
      </div>
      <el-pagination
        class="pagination"
        :total="total"
        background
        :current-page="pageCount"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
    <Footer />
  </div>
</template>

<script>
import { getConsultingService } from '@/api/index.js'
export default {
  name: 'InformationCenter',
  data () {
    return {
      isshow: 1,
      type: 0, //请求数据类型
      total: 0, //总量
      pageCount: 1,//请求的页码
      pageList: [],//资讯列表
      pagesize: 5, //请求的数量

      topList: [] //推荐资讯列表

    }
  },
  mounted () {
    this.getConsultingServiceData()
    this.getqysjTopDataList()
  },
  methods: {
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
      // console.log('eeeeeeeee', e.srcElement.scrollTop, e.target.scrollTop)
    },

    goleft () {

      this.$refs.toploop.setActiveItem(0)
    },
    gocenter () {

      this.$refs.toploop.setActiveItem(1)

    },
    goright () {

      this.$refs.toploop.setActiveItem(2)

    },
    handleCurrentChange (num) {
      // console.log(num)
      this.pageCount = num
      this.getConsultingServiceData()
    },
    toqysj () {
      this.pageCount = 1
      this.type = 0
      this.isshow = 1
      this.getqysjTopDataList()
      this.getConsultingServiceData()
    },
    tohyxw () {
      this.type = 1
      this.isshow = 2
      this.pageCount = 1
      this.gethyxwTopDataList()
      this.getConsultingServiceData()
      // console.log(this.isshow)
    },
    //跳转企业事纪
    async getConsultingServiceData () {
      const res = await getConsultingService(this.type, 5, this.pageCount)
      // const data = await getConsultingService(this.type)
      this.pageList = res.data.list
      this.total = res.data.total
      console.log('总数据', res.data)
      // console.log('资讯列表', this.pageList)
    },
    // 获取企业世纪的top推荐资讯
    async getqysjTopDataList () {
      const res = await getConsultingService(2, 3, 0)
      this.topList = res.data.list
      console.log('1tops', this.topList)
    },
    // 获取企业世纪的top推荐资讯
    async gethyxwTopDataList () {
      const res = await getConsultingService(3, 3, 0)
      this.topList = res.data.list
      // console.log('2tops',this.topList);
    },
    //带参跳转详情页
    toDetail (item) {

      this.$router.push({
        path: `/Informationdetails`,
        query: { id: item.id,
        type:this.type }
      })
    },
    getMore (item) {
      //  const itemOBJ = JSON.stringify(item)
      //  window.sessionStorage.setItem('item',itemOBJ);
      // console.log(item);
      this.$router.push({
        path: `/Informationdetails`,
        query: { id: item.id }
      })

    }
  }

}
</script>

<style lang="scss" scoped>
.loop-line {
  margin-top: 60px;
  width: 110px;
  display: flex;
  justify-content: center;
  .loopbox {
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      margin-right: 10px;
      width: 30px;
      height: 2px;
    }
    div:nth-child(3) {
      margin-right: 0px;
    }
    .leftline {
      background: #bbbbbb;
      opacity: 0.3;
    }
    .centerline {
      background: #bbbbbb;
      opacity: 0.3;
    }
    .rightline {
      background: #bbbbbb;
      opacity: 0.3;
    }
  }
  .loopbox:hover {
    div {
      background-color: red;
    }
  }
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.mainbody {
  width: 100%;
  margin-top: 80px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .top-title {
    flex-direction: row;
    display: flex;
    div {
      width: 180px;
      height: 60px;
      background-color: #f4f4f4;
      text-align: center;
      line-height: 60px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    div.active {
      background-color: #1c43bd;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
  }

  .zixun {
    // padding-bottom: 40px;
    margin-top: 120px;
    box-shadow: 0px 0px 16px 0px rgba(41, 41, 41, 0.08);
    width: 1200px;
    // background-color: #37a5d8;

    .loops {
      width: 100%;
      display: flex;
    }
    .left {
      flex: 1;
      width: 600px;
      height: 385px;
      background-color: #f4f4f4;
    }
    .right {
      flex: 1;
      width: 600px;
      height: 385px;
      // border: 1px solid;
      padding: 35px;

      .title {
        // text-align: center;
        display: inline-block;
        width: 527px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #1c43bd;
        // background-color: red;
      }
      .textbody {
        margin-top: 30px;
        // width: 520px;
        height: 100px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        display: block;
        width: 100%;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
      }
      .time {
        margin-top: 31px;
        width: 400px;
        height: 12px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .watchmore {
        margin-top: 50px;
        width: 89px;
        height: 35px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        // border: 1px solid #000;
      }
    }
  }
  .newsList {
    margin-top: 60px;
    width: 1200px;
    margin-bottom: 60px;
    .childnew {
      width: 1200px;
      height: 224px;
      background: #ffffff;
      padding-top: 20px;
      padding-bottom: 20px;
      display: flex;
      transition: 0.5s;
      margin-bottom: 9px;
      img {
        width: 285px;
        height: 180px;
        background-color: #f4f4f4;
        margin-right: 20px;
      }
      .right-text {
        .top {
          width: 850px;
          height: 70px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 400;
        }
        
        .center {
          margin-top: 10px;
          width: 834px;
          height: 45px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
           display: block;
        // width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        }
        .under-time {
          margin-top: 30px;
          width: 588px;
          height: 12px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .childnew:hover {
      box-shadow: 0px 0px 16px 0px rgba(41, 41, 41, 0.08);
      padding-left: 20px;
      transition: 0.5s;
      z-index: 39;
      .top {
          color: #1c43bd;
        }
    }
  }
  .pagination {
    margin-bottom: 200px;
  }
  // .qysj {
  //   width: 180px;
  //   height: 60px;

  // }
}
.headerbg {
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/information/headbg.png");
  height: 580px;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #0a63dc;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Information-Center.vue